import api from './api';
import { clearTheme } from '../utils/themeUtils';

// LAKPED-12: la cuenta se deduce del email; accountSlug solo si alguna vez hay que forzarla
export const login = async (email, password, accountSlug = null) => {
  const response = await api.post('/auth/login', {
    email,
    password,
    ...(accountSlug ? { account_slug: accountSlug } : {}),
  });

  if (response.data.access_token) {
    localStorage.setItem('token', response.data.access_token);
    localStorage.setItem('user', JSON.stringify(response.data.user));
    localStorage.setItem('account', JSON.stringify(response.data.account));
  }

  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('account');
  clearTheme();
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const getCurrentAccount = () => {
  const account = localStorage.getItem('account');
  return account ? JSON.parse(account) : null;
};

export const isSystemAdmin = () => {
  const account = getCurrentAccount();
  return account && account.slug === 'kuikia';
};

export const isAccountAdmin = () => {
  const user = getCurrentUser();
  return user && user.role && user.role.is_admin;
};
// NUBBI-102 — flags de cuenta frescos desde /me (el localStorage puede ser de un login antiguo)
export const fetchAccountFlags = async () => {
  const response = await api.get('/auth/me');
  return response.data?.account || {};
};
